import Responsive from "./Responsive";
import SmoothScroll from './SmoothScroll';
import SpNavi from "./SpNavi";
import ToTop from "./ToTop";
import bowser from "bowser";
import easeScroll from "./jquery.easeScroll.js";
import inview from "jquery-inview";
import FloatAnimation from "./FloatAnimation";
import slick from "slick-carousel";
import { TweenMax, TimelineMax } from "gsap";
import Swiper from "swiper";
import remodal from "remodal";

if (bowser.msie === true) {
	let version = "ie_" + Math.floor(bowser.version);
	$("body").addClass("ie " + version);
} else if (bowser.msedge === true) {
	$("body").addClass("edge");
} else if (bowser.firefox === true) {
	$("body").addClass("ff");
} else if (bowser.tablet === true) {
	$("body").addClass("tablet");
}

if (bowser.mobile === true) {
	$("body").addClass("device--mobile");
	if (bowser.android === true) {
		$("body").addClass("device--mobile--android");
	}
}

let os,
	ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
} else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
} else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
} else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
} else {
	os = "";
}

$("body").addClass(os);

if (ua.indexOf("Android") > 0) {
	$("body").addClass("device--mobile");
	$("body").addClass("device--mobile--android");
}
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());



/* ===============================================
Smooth Scroll
=============================================== */
// const sms = new SmoothScroll();
// sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
let param = {
	target: ".c-floatNav",
	// stop_at: "",
	fixer: 400
};

const totop = new ToTop(param);
totop.exec();

let param_won = {
	target: "#wovn-translate-widget",
	// stop_at: ".l-footerimg",
	fixer: 400
};

const totop_won = new ToTop(param_won);
totop_won.exec();

/* ===============================================
#	global header
=============================================== */
const _w = $(window);
_w.on("load scroll", function() {
	let header = $(".js-global_header"),
		mvHeight = $(".mv").height(),
		scroll = $(this).scrollTop();
	if (scroll > mvHeight) {
		header.addClass("is-show");
		$("#wovn-translate-widget").addClass("-is-display");
	} else {
		header.removeClass("is-show");
		$("#wovn-translate-widget").removeClass("-is-display");
	}
});

/**/
// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty("--vh", `${vh}px`);


$(".js-mv-arrow-scroll").on("click", function() {
	let section_lower_Y = $(".l-section_home").offset().top;
	$("html,body").animate({ scrollTop: section_lower_Y }, 500, "swing");
});


/* ===============================================
SP Navi
=============================================== */
//通常版
let spnavi_param = {
  target: "#spnavi",
  trigger: ".btn_sp_navi",
  filter: "resposive_flg",
  speed: 200,
};

const navitems = Array.from(document.querySelectorAll(".js-nav"));
navitems.forEach((navitem) => {
  var letters = navitem.innerHTML.split("");
  navitem.innerHTML = "";
  letters.forEach((letter) => {
    var span = document.createElement("span");
    span.innerHTML = letter;
    navitem.appendChild(span);
  });
});

class SpNavi_extend extends SpNavi {
  close(targetObj) {
    for (var i = 0; i < $(".js-nav span").length; i++) {
      (function (ind) {
        setTimeout(function () {
          $(".js-nav span").eq(ind).removeClass("show");
        }, ind * 10);
      })(i);
    }
    setTimeout(() => {
      super.close(targetObj);
      setTimeout(() => {
				$(".l-global_header").attr({ style: "" });
				$(".l-global_header").removeClass("is-active-navmenu");
      }, this.speed);
		}, $(".js-nav span").length * 10 + 600);
  }
  open(targetObj, callbacks) {
    $(".l-global_header").css({
      height: "100%",
      transform: "translateY(0)",
		});
		$(".l-global_header").addClass("is-active-navmenu");
    super.open(targetObj, callbacks);
    for (var i = 0; i < $(".js-nav span").length; i++) {
      (function (ind) {
        setTimeout(function () {
          $(".js-nav span").eq(ind).addClass("show");
        }, ind * 10);
      })(i);
    }
  }
}

const spnavi = new SpNavi_extend(spnavi_param);
spnavi.exec();








/* ===============================================
#	navigagion
=============================================== */
// const spnavi = $("#spnavi");

// //.section下部マージン調節
// const addOffset = () => {
// 	let sectionH = $(".section").height();
// 	let thumbnailhomeH = $(".p-thumbnailhome").height();
// 	let result = sectionH - thumbnailhomeH;
// 	if (result > 0) {
// 		$(".p-thumbnailhome").css({ "margin-bottom": result });
// 	}
// };

// const addOffsetClear = () => {
// 	$(".p-thumbnailhome").css({ "margin-bottom": 0 });
// };

// //閉じる
// const naviClose = () => {
// 	// $("#spnavi").removeClass("-scroll");
// 	// $(".c-nav").removeClass("-is-open");
// 	$("#spnavi").removeClass("-active");
// 	$(".p-naviarea").removeClass("-show");
// 	// $(".btn_sp_navi").removeClass("active");
// 	$(".btn_sp_navi .text").css("display","block");
// 	// $(".spnavi").css("display","none");
// 	// initScrollify();
// 	addOffsetClear();
// 	$("body").removeClass("-fixed");
// 	if ($("body").hasClass("home")) {
// 		// $.scrollify.instantMove("#cont");
// 	}
// };
// //開く
// const naviOpen = () => {
// 	$("#spnavi").addClass("-active");
// 	// $(".c-nav").addClass("-is-open");
// 	$(".p-naviarea").addClass("-show");
// 	// $(".btn_sp_navi").addClass("active");
// 	$(".btn_sp_navi .text").css("display","none");
// 	// $(".spnavi").css("display","block");
// 	addOffset();
// 	// $.scrollify.destroy();
// 	TweenMax.delayedCall(0.5, function() {
// 		$("body").addClass("-fixed");
// 		// $("#spnavi").addClass("-scroll");
// 	});
// };

// $(".btn_sp_navi").on("click", function() {
// 	if (spnavi.hasClass("-active")) {
// 		naviClose();
// 	} else {
// 		naviOpen();
// 	}
// });

// $(".p-naviarea").on("click", function(e) {
// 	if (spnavi.hasClass("-active")) {
// 		naviClose();
// 	} else {
// 		naviOpen();
// 	}
// });


/* ===============================================
#	blockfade パーツ全体をfadeINする。
=============================================== */

$(".js-block-fade").on("inview", function() {
	$(this).addClass("-is-active");
	setTimeout(() => {
		$(this)
			.find(".js-block-fade-child")
			.addClass("-is-active");
	}, 500);
	$(this).off("inview");
});

$(".js-inview-element").on("inview", function () {
    $(this).addClass("-is-active");
    $(this).off("inview");
});

/* ===============================================
#	home categpry slide use swiper
=============================================== */
$(".js-categorySlide").each(function() {
	let _this = $(this),
		target = $(_this).find(".js-categorySlideTarget"),
		cat = _this.data("cat"),
		counter = 1,
		speed = 4000,
		attr = [];

	function get_attr(attr) {
		$(target).each(function() {
			let children = $(this).children();
			$(children).each(function() {
				let child_style = $(this).css("background-image");
				let child_href = $(this).attr("href");
				attr.push({ style: child_style, href: child_href });
			});
		});

		for (let i = attr.length - 1; i > 0; i--) {
			let r = Math.floor(Math.random() * (i + 1)),
				tmp = attr[i];
			attr[i] = attr[r];
			attr[r] = tmp;
		}
		return attr;
	}
	get_attr(attr);

	let i = 0;
	$(target).each(function() {
		let children = $(this).children(),
			t = $(this),
			// opacity = _this.hasClass("pc") ? 1 : 0;
			opacity = 0;
		speed = speed * counter;
		$(children).each(function() {
			$(this).css({
				"background-image": attr[i].style,
				opacity: opacity
			});
			$(this).attr("href", attr[i].href);
			i++;
		});
		$(this)
			.children()
			.eq(0)
			.css({ opacity: 1 });

		let l = 0,
			looplv = 0,
			array = [l, speed, children, counter, looplv],
			loop = array => {
				let l = array[0],
					speed = array[1],
					children = array[2],
					counter = array[3],
					looplv = array[4];

				if (l == 0) {
					$(children)
						.eq(children.length - 1)
						.css({ opacity: "0", "z-index": "0" });
					$(children)
						.eq(l)
						.css({ opacity: "1", "z-index": "1" });
				} else {
					$(children)
						.eq(l - 1)
						.css({ opacity: "0", "z-index": "0" });
					$(children)
						.eq(l)
						.css({ opacity: "1", "z-index": "1" });
				}

				if (l == children.length - 1) {
					l = 0;
				} else {
					l++;
				}

				if (counter == 1 && looplv == 0) {
					speed = speed * 2;
				}
				looplv++;
				clearTimeout(loop);
				setTimeout(loop, speed, [l, speed, children, counter, looplv]);
			};
		setTimeout(loop, speed, array);
		counter++;
	});
});


/* ===============================================
#	navigagion btn fade in/out
=============================================== */
// const navShow = () => {
// 	let startPos = 0;
// 	_w.on("load resize scroll", function() {
// 		const target = $(".l-contents .c-nav");
// 		let s = $(window).scrollTop();
// 		if (s < 30) {
// 			target.addClass("-is-hide");
// 		} else {
// 			target.removeClass("-is-hide");
// 		}
// 		startPos = s;
// 	});
// };
// navShow();

let timeoutId;
let checkPoint = 0;
let wt = 0;

$(window).on('scroll', function() {
	let hidePos = $('.p-desc').offset().top + $('.p-desc').height();
	wt = $(window).scrollTop();

	if (30 < wt) {
		$(".l-global_header").addClass("_is-active");
	} else {
		$(".l-global_header").removeClass("_is-active");
	}

	if (hidePos < wt) {
		if (checkPoint > wt) {
			if ($(".l-global_header").hasClass("_is-hide")) {
				$(".l-global_header").removeClass("_is-hide");
			}
		} else {
			$(".l-global_header").addClass("_is-hide");
		}
	}
	checkPoint = wt;
});

/* ===============================================
#	footer float nav
=============================================== */
$(document).ready(function() {
	$(window).on("scroll", function() {
		let scrollHeight;
		let scrollPosition;
		let footHeight;
		scrollHeight = $(document).height(); //ドキュメントの高さ
		scrollPosition = $(window).height() + $(window).scrollTop(); //現在地
		footHeight =
			$(".p-footerContact").innerHeight() +
			$(".l-globalFooter").innerHeight() +
			10; //footerの高さ（＝止めたい位置）
		if (scrollHeight - scrollPosition <= footHeight) {
			//ドキュメントの高さと現在地の差がfooterの高さ以下になったら
			$(".c-floatNav,#wovn-translate-widget").css({
				position: "absolute",
				bottom: footHeight
			});
		} else {
			$(".c-floatNav,#wovn-translate-widget").css({
				position: "fixed"
			});
		}
	});
});

/* ===============================================
#	mv 2020sp
=============================================== */
// スライドをシャッフル
const shuffleAarray = array => {
	for (let i = array.length - 1; i >= 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
};

const target_slide = document.querySelectorAll(".p-homeMv_slide");

let slide_array = [];
target_slide.forEach((elem, index) => {
	slide_array.push(elem);
});
const slide_array_shuffled = shuffleAarray(slide_array);

slide_array_shuffled.forEach(function(elem) {
	document.querySelector(".swiper-wrapper").appendChild(elem);
});

// MVスクロールでフェードアウト
$(window).on("scroll", function() {
	let scrollTop = $(window).scrollTop();
	if (scrollTop > 30) {
        $('.p-mv').addClass('-is-scroll');
	} else {
        $('.p-mv').removeClass('-is-scroll');
	}
});


/* ===============================================
# p-product_item にmod-adjustが付与されたとき、
# ラスト四個の影付き方を調整
=============================================== */
const productList = document.querySelectorAll('.p-product_list');
productList.forEach((item)=>{
	const itemArray = item.querySelectorAll('.p-product_item');
	const itemLength = itemArray.length;
	switch (itemLength){
		case 7:
		// itemArray[5].classList.add('has-shadow');
		// itemArray[6].classList.add('no-shadow');
		item.classList.add('mod-length-7')
		break;
	}

})

/* ===============================================
# concept slider
=============================================== */
const conceptSlider = new Swiper(".js-concept-swiper", {
    loop: true,
    speed: 2000,
    effect: "fade",
    simulateTouch: false,
    noSwiping: true,
    autoplay: 5000
});


/* ===============================================
# scrollbar
=============================================== */

$('.p-news_inner').on("scroll", function() {
	let timeoutId;
	$('.p-news_inner').addClass("_is-show");
	clearTimeout( timeoutId ) ;
	timeoutId = setTimeout( function () {
		if ($('.p-news_inner').hasClass("_is-show")) {
			$('.p-news_inner').removeClass("_is-show");
		}
	}, 300 ) ;
});


/* ===============================================
# mv
=============================================== */
var getDevice = (function () {
	var ua = navigator.userAgent;
	if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
		return 'sp';
	} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
		return 'tb';
	} else {
		return 'other';
	}
})();

const arrayRandom = array => {
	if (Array.isArray(array)) {
		for (let i = array.length - 1; i >= 0; i--) {
			let r = Math.floor(Math.random() * (i + 1));
			let tmp = array[i];
			array[i] = array[r];
			array[r] = tmp;
		}
		return array;
	} else {
		return false;
	}
}
const mv_shuffle = () => {
	const target = $(".js-mv");
	if (target && target.length > 0) {
		target.each(function () {
			let images = [];
			let children = $(this).children();
			children.remove();
			children.each(function (i) {
				images.push(children[i]);
			});
			if (images.length === 0) {
				return false;
			}
			images = arrayRandom(images);
			for (let i = 0; i < images.length; i++) {
				$(this).append(images[i]);
			}
		});
	}
};
mv_shuffle();

const mv_animation = () => {
	const target = $(".js-mv");
	if (target && target.length > 0) {
		target.each(function () {
			let looptime = 4000;
			looptime = $(this).data("looptime")
				? $(this).data("looptime")
				: looptime;

			let ShuffleChildren = $(this).children();
			let counter = 1;
			setInterval(function () {
				ShuffleChildren.eq(counter - 1).removeClass("_is-show");
				ShuffleChildren.eq(counter).addClass("_is-show");
				if (counter < ShuffleChildren.length - 1) {
					counter += 1;
				} else {
					counter = 0;
				}
				if(ShuffleChildren.eq(counter).hasClass("_is-first-elm")) {
					ShuffleChildren.eq(counter).removeClass("_is-first-elm");
				}
			}, looptime);
		});
	}
};

let tl = new TimelineMax({
		onComplete: mv_animation
	}
);
// tl.set(".p-mv-logo", {className: "p-mv-logo _is-show"}, 0.5);
tl.set(".p-mv-logo-inner", {className: "p-mv-logo-inner _is-show"}, 0.5);

let firstElm = $(".pc.js-mv").children().eq(0);
$(firstElm).addClass('_is-first-elm');
tl.set(
	firstElm,
	{ className: '+=_is-show' },
	1.0
);

if (getDevice == 'sp' || $(window).width() < 600){
	let firstElm = $(".sp.js-mv").children().eq(0);
	$(firstElm).addClass('_is-first-elm');
	tl.set(
		firstElm,
		{ className: '+=_is-show' },
		1.0
	);

} else if (getDevice == 'tb' || $(window).width() <= 1024) {
	let firstElm = $(".tb.js-mv").children().eq(0);
	$(firstElm).addClass('_is-first-elm');
	tl.set(
		firstElm,
		{ className: '+=_is-show' },
		1.0
	);
}

tl.set(".p-mv-bg-wrap", {className: "p-mv-bg-wrap _is-show"}, 1.5);
tl.set(".p-mv-arrow", {className: "p-mv-arrow _is-show"}, 2.2);


/* ===============================================
# スクロール遅延
=============================================== */


$(function () {
	$(window).on('load', function () {
			if ($(window).width() > 1024) {
					// inertiaScrollを使用の場合
					// $(".l-main").inertiaScroll({
					//     parent: $(".l-wrap"),
					//     childDelta1: 0.01,
					//     childDelta2: 0.08,
					//     parentDelt: 0.04,
					// });
					// $(window).on('resize', function() {
					//     $("body").height($(".l-wrap").innerHeight());
					// });
					// easeScrollを使用の場合
					$("html").easeScroll({
							// オプションが必要な場合
							// frameRate: 100,
							// animationTime: 1000,
							// stepSize: 45,
							// pulseAlgorithm: 1,
							// pulseScale: 8,
							// pulseNormalize: 1,
							// accelerationDelta: 20,
							// accelerationMax: 1,
							// keyboardSupport: true,
							// arrowScroll: 30,
							// touchpadSupport: true,
							// fixedBackground: false,
					});
			}
	});
});

$(function() {
		// $('.p-homeMv_gradation').on('animationend', function(){
		// 	$('.p-homeAnime_white').css('display','block');
		// 	$('.p-homeMv_gradation').css('display','none');
		// 	$('.p-homeMv_texture').css('display','none');
		// 	$('.p-homeMv_plane').addClass('plane');
		// });
		// $('.p-homeMv_plane').on('animationend', function(){
		// 	$('.p-homeMv_texture').css('display','none');
		// 	$('.p-homeMv_plane').css('display','none');
		// 	$('p-homeMv_logo').css('display','none');
		// 	$('.p-homeMv_white').addClass('white-animation');
		// 	$('.swiper-wrapper').addClass('slider-animation');
		// });
		setTimeout(function(){
			$('.p-mv-open.mod-01').addClass('is_show');
		},500);
		setTimeout(function(){
			$('.p-mv-open.mod-02').addClass('is_show');
		},800);
		setTimeout(function(){
			$('.p-mv-open.mod-03').addClass('is_show');
		},1100);
		setTimeout(function(){
			$('.p-mv-open').fadeOut();
		},1700);
		setTimeout(function(){
			$('.p-mv-plane').css("display","none")
		},2100);
		setTimeout(function(){
			$('.p-mv-logo').addClass('fade-in');
		},1400);
		setTimeout(function(){
			$('.p-mv-col').addClass('fade-in');
		},1400);

});